<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" [ngClass]="{ expanded: displayMode === DisplayMode.Form }" hideToggle class="panel-list">
        <mat-expansion-panel-header
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            collapsedHeight="48px"
            expandedHeight="48px"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Modèles de SMS"
                createIconText="Ajouter un modèle"
                importDatasourceName="smstemplates"
                (created)="onSmsTemplateCreated()"
                (exported)="onSmsTemplateExported()"
                (imported)="onSmsTemplateImported()"
                (helped)="onSmsTemplateHelped()"></app-list-header>
        </mat-expansion-panel-header>

        <app-sms-templates-list
            #itemsList
            [global]="global"
            (itemSelected)="onSmsTemplateSelected($event)"
            (itemDisplayed)="onSmsTemplateDisplayed($event)"
            (itemEdited)="onSmsTemplateEdited($event)"
            (itemDeleted)="onSmsTemplateDeleted($event)"
            (itemDuplicated)="onSmsTemplateDuplicated($event)"></app-sms-templates-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onSmsTemplateDisplayed(context?.formContext.item)"
                    (edited)="onSmsTemplateEdited(context?.formContext.item)"
                    (helped)="onSmsTemplateHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-sms-template-detail [context]="context" (smsTemplateUpdated)="onSmsTemplateUpdated($event)" (canceled)="onBackToList()"></app-sms-template-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
